import { render, staticRenderFns } from "./c_player_teacherinfo.vue?vue&type=template&id=36303c10"
import script from "./c_player_teacherinfo.vue?vue&type=script&lang=js"
export * from "./c_player_teacherinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports